import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  private visibilitySource = new BehaviorSubject<boolean>(false);
  visibility$ = this.visibilitySource.asObservable();

  toggleVisibility() {
    this.visibilitySource.next(!this.visibilitySource.value);
  }
}
